import { Box, InputAdornment, TextField } from "@mui/material"
import { SearchOutlined } from "@mui-symbols-material/w300"
import { useNavigate } from "@tanstack/react-router"
import type { ChangeEvent } from "react"

interface TableHeaderActionsProps<T extends { query?: string }> {
  currentSearch: T
  children: React.ReactNode
  placeholder?: string
  navigateTo?: string
  testIdPrefix?: string
}

export const TableHeaderActions = <T extends { query?: string }>({
  currentSearch,
  children,
  placeholder,
  navigateTo,
  testIdPrefix,
}: TableHeaderActionsProps<T>): JSX.Element => {
  const navigate = useNavigate()

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const queryValue = e.target.value.trim()

    const updatedSearch: T = {
      ...currentSearch,
      query: queryValue,
    }

    navigate({
      to: navigateTo,
      search: updatedSearch,
      replace: true,
    })
  }

  return (
    <Box className='flex space-x-4'>
      <TextField
        data-testid={testIdPrefix ? `${testIdPrefix}.search-input` : "search-input"}
        variant='outlined'
        placeholder={placeholder || "Search..."}
        defaultValue={currentSearch?.query}
        className='w-full max-w-lg'
        onChange={handleSearchInputChange}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position='start'>
                <SearchOutlined className='text-gray-600' />
              </InputAdornment>
            ),
          },
        }}
      />
      <Box className='flex w-full justify-between'>{children}</Box>
    </Box>
  )
}
